module.exports = __webpack_public_path__ + "images/e056d4f2aab67b2102d7be59635de415-staying-pic-sikkim.png";